module.exports = __webpack_public_path__ + "static/img/金融背景@2x.4300856.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/供应链金融/金融背景@2x.png
// module id = oqn0
// module chunks = 192